import {
  Int32IdAndLabel,
  GuidIdCodeAndLabel,
  StationOrLocationItem,
  GuidIdAndLabel, BrandAndMarketListItem,
} from '../../../integrated-client/models';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IAutocompleteObject {
  id: string
  code: string
  label: string
}

export class AutocompleteObject implements IAutocompleteObject {
  id: string
  code: string
  label: string

  constructor() {
    this.id = ''
    this.code = '';
    this.label = '';
  }
}

export const DEFAULT_LIMIT = 21;

export interface IFormData {
  brandAndMarket: BrandAndMarketListItem | null
  distributionChannel: Int32IdAndLabel | null
  agency: GuidIdCodeAndLabel | null
  agencyOnly?: boolean | null
  description: string | null
  relevance: number | null
  origin: StationOrLocationItem | null
  destination: StationOrLocationItem | null
  supplier?: GuidIdAndLabel | null
  carrier?: GuidIdCodeAndLabel | null
  bookingClass?: string | null
  contractFareType?: string | null
  fareBasisCode?: string | null
  ticketDesignator?: string | null
  marketingFlightNumbers?: string | null
  marketingAndOperatingCarriers?: any
  showDisabled: boolean
  orderByRelevanceAscending?: boolean
  showDeleted: boolean
  offset: number | null
  limit: number | null
  total: number
  currentPage: number
}

export class FormData implements IFormData {

  brandAndMarket: BrandAndMarketListItem | null
  distributionChannel: Int32IdAndLabel | null
  agency: GuidIdCodeAndLabel | null
  description: string | null
  relevance: number | null
  origin: StationOrLocationItem | null
  destination: StationOrLocationItem | null
  showDisabled: boolean
  showDeleted: boolean
  offset: number | null
  limit: number | null
  total: number
  currentPage: number

  constructor() {
    this.brandAndMarket = null;
    this.distributionChannel = null;
    this.agency = null;
    this.description = null;
    this.relevance = null;
    this.origin = null;
    this.destination = null;
    this.showDisabled = false;
    this.showDeleted = false;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }

}
